import React from 'react';

import PropTypes from 'prop-types';

import getPluginKey from '../helpers/getPluginKey';
import { pluginShape } from '../helpers/propTypes';

const PluginProvidersProvider = ({ plugins, children }) => {
  return plugins.reduce((content, plugin) => {
    if (plugin.Provider) {
      return (
        <plugin.Provider key={getPluginKey(plugin)}>{content}</plugin.Provider>
      );
    }
    return content;
  }, children);
};

PluginProvidersProvider.propTypes = {
  plugins: PropTypes.arrayOf(pluginShape).isRequired,
  children: PropTypes.node,
};

export default PluginProvidersProvider;
